module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAABAElEQVQ4je3UP0qDQRAF8N9ngqISFFFyAUFS23sGrcQLCIKFJxFFsbfwHp5BLC1VEAT/IMQUMrK4kTV+gRBT+mAZdvbNYx67OyaGiBhcaxFxF/W4j4jOYE1CEzOYLRrbxAe2apo9xg4Oi1wXvSoinrHwB4cvVVUtpo42sIR9rOJghOIj3OAUj31rV4WlZVyOIJRc3JbcqRpSAydoYx5nObZzvlGnXCfUyjY7WMFejp2cb40qNBb+hcYT6uEVT/n591fav+XzX2gWicjC3YEvM5fjQ3H1iff1WzNKoWvsYjsXDUN6mOs4/0EoxsF0RFxExPuQEdJHOk+8xP8eI5MBPgFZ7J3WCD+QbwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/subDevice/son_btn_delete.png
// module id = Rqn9
// module chunks = 4